import { TripPackageStatusFilter } from './TripPackageStatusFilter';
import { usePackagesFilters } from './usePackagesFilters';
import { t } from '../../services/translation/translation';

export const TripPackageFilters = () => {
  const { handleChange, handleReset } = usePackagesFilters();
  return (
    <div className="flex items-center gap-2 mb-2">
      <p className="text-sm font-normal text-gray-500 dark:text-gray-400">{t('common.filters')}</p>

      <TripPackageStatusFilter onChange={handleChange} />

      <button
        type="button"
        className="font-medium text-blue-600 dark:text-blue-500 hover:underline text-sm"
        onClick={handleReset}
      >
        {t('common.reset')}
      </button>
    </div>
  );
};
